import React, { useCallback, useEffect, useReducer, useState } from "react"
import { periodoPadrao7Dias } from "../../../functions/periodoData"
import { obterHistoricoCaixa } from "../../../services/historicoCaixa"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { HistoricoCaixaInicial } from "../models/historicoCaixaModel"
import { HistoricoCaixaActionsTypes } from "./historicoCaixaActions"
import { HistoricoCaixaContext } from "./HistoricoCaixaContext"
import { historicoCaixaReducer } from "./historicoCaixaReducer"

export function HistoricoCaixaContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(historicoCaixaReducer, HistoricoCaixaInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const periodoInicial = periodoPadrao7Dias()
    const [dataInicio, setDataInicio] = useState(periodoInicial.inicio)
    const [dataFim, setDataFim] = useState(periodoInicial.fim)
    const setLoading = useLoadingStore(s => s.setLoading)
    const idEstabelecimento = useAppStore(
        s => s.configuracoes?.user?.parametros?.estabelecimento?.id
    )

    const carregar = useCallback(
        async (inicio?: string, fim?: string) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                const response = await obterHistoricoCaixa(
                    autorizacao,
                    inicio || undefined,
                    fim || undefined,
                    idEstabelecimento
                )
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar histórico do caixa")
                } else {
                    setErroCarregamento(null)
                    dispatch({ type: HistoricoCaixaActionsTypes.CARREGAR, payload: response })
                }
            } catch {
                setErroCarregamento("Erro ao carregar histórico do caixa")
            } finally {
                setLoading(false)
            }
        },
        [setLoading, idEstabelecimento]
    )

    useEffect(() => {
        carregar(periodoInicial.inicio, periodoInicial.fim)
    }, [])

    return (
        <HistoricoCaixaContext.Provider
            value={{
                dados,
                dispatch,
                erroCarregamento,
                dataInicio,
                dataFim,
                setDataInicio,
                setDataFim,
                recarregar: carregar,
            }}
        >
            <Loading />
            {children}
        </HistoricoCaixaContext.Provider>
    )
}
